<template>
  <div class="text-left readers-list mt-4">
    <sdui-waterfall-search v-model="notAnsweredUsers"
                           class="p-0 outer-list"
                           :url="url"
    >
      <!-- Users not answered list -->
      <template #content>
        <SList class="user-open-list" data-cy="user-open-list">
          <sdui-user-list-item
            v-for="(reader, i) in notAnsweredUsers"
            :key="`reader-${i}`"
            :user="new User(reader.user)"
            :prevent-hover="true"
          >
            <template #action>
              <div />
            </template>
          </sdui-user-list-item>
        </SList>
      </template>
    </sdui-waterfall-search>
  </div>
</template>

<script>
import SduiWaterfallSearch from 'src/components/miscellaneous/ui/common/SduiWaterfallSearch.vue'
import SduiUserListItem from 'src/components/user/SduiUserListItem.vue'
import { User } from 'src/store/models/index.js'
import Channels from 'src/api/channels.js'

export default {
  name: 'SduiMultiQuestionSurveyVotersListOpen',
  components: { SduiUserListItem, SduiWaterfallSearch },

  props: {
    survey: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    notAnsweredUsers: [],
    User: User,
  }),

  computed: {
    url() {
      return `${Channels.channelSurveyResultsAnsweredByIdUrl(this.survey.id, false)}&`
    },
  },
}
</script>
